import { encodeHtml } from './skyward.base.extensions';
import { registerEvents } from "./skyward.ui.events";
import { SkyVueData } from "./vue/skyVue/core/store/types";
import { HTMLEditorClasses } from "./vue/skyVue/htmlEditor/classes";
import { htmlEditorStore } from "./vue/skyVue/htmlEditor/store";
import { HTMLEditorStoreState } from "./vue/skyVue/htmlEditor/store/types";

const events = {};

registerEvents("htmlEditor", events);

const elements =
{
    htmlEditorWrapper:
    {
        className: HTMLEditorClasses.Container,
        getOuterWrapper: (element: JQuery<HTMLElement>) => element
    },
    htmlEditorBackingInput:
    {
        className: HTMLEditorClasses.HiddenInput,
        getOuterWrapper: (element: JQuery<HTMLElement>) => element.parents(`.${elements.htmlEditorWrapper.className}`)
    },
    froalaWrapperBox:
    {
        className: HTMLEditorClasses.FroalaBox,
        getOuterWrapper: (element: JQuery<HTMLElement>) => element.parents(`.${elements.htmlEditorWrapper.className}`)
    },
};

function getWrapperElement(element: JQuery<HTMLElement>): JQuery<HTMLElement> | null
{
    let wrapperElement: JQuery<HTMLElement> | null = null;
    for (const elementType of Object.values(elements))
    {
        if (element.hasClass(elementType.className))
        {
            wrapperElement = elementType.getOuterWrapper(element);
            if (wrapperElement !== null && wrapperElement.length > 0)
            {
                break;
            }
            else
            {
                wrapperElement = null;
            }
        }
    }
    return wrapperElement;
}

export function isHtmlEditorElement(element: JQuery<HTMLElement>): boolean
{
    return getWrapperElement(element) !== null;
}

export function containsHtmlEditorElement(element: JQuery<HTMLElement>): boolean
{
    for (const elementType of Object.values(elements))
    {
        const childElements = element.find(`.${elementType.className}`);
        if (element.hasClass(elementType.className) || childElements.length > 0)
        {
            return true;
        }
    }
    return false;
}

function getState(wrapperElement: JQuery<HTMLElement> | null): HTMLEditorStoreState | null
{
    if (wrapperElement && wrapperElement.length > 0)
    {
        const skyvue = wrapperElement.data("skyvue") as SkyVueData;
        if (skyvue && htmlEditorStore.hasState(skyvue.id))
        {
            return htmlEditorStore.getState(skyvue.id);
        }
    }
    return null;
}

function getValue(element: JQuery<HTMLElement>): string | null
{
    const wrapperElement = getWrapperElement(element);
    const state = getState(wrapperElement);
    if (state)
    {
        return state.features.settings.value
    }
    return null;
}

export function getEncodedValue(element: JQuery<HTMLElement>): string | null
{
    const value = getValue(element);
    return value !== null ? encodeHtml(value) : null;
}

export function setValue(element: JQuery<HTMLElement>, value: string, supressChangeEvent: boolean = false): JQuery<HTMLElement> | undefined
{
    const wrapperElement = getWrapperElement(element);
    const state = getState(wrapperElement);
    if (state)
    {
        state.features.settings.value = value;

        if (!supressChangeEvent)
        {
            wrapperElement?.trigger("change");
        }
    }
    return wrapperElement ?? undefined;
}

export function clearValue(element: JQuery<HTMLElement>, supressChangeEvent: boolean = false): JQuery<HTMLElement> | undefined
{
    return setValue(element, "", supressChangeEvent);
}

export function getOriginalValue(element: JQuery<HTMLElement>): string | null
{
    const wrapperElement = getWrapperElement(element);
    const backingElement = wrapperElement?.find(`.${elements.htmlEditorBackingInput.className}`);
    if (backingElement && backingElement.length > 0)
    {
        return backingElement.data("originalValue") as string;
    }

    return null;
}

export function toggle(element: JQuery<HTMLElement>, isEnabled: boolean): JQuery<HTMLElement> | undefined
{
    const wrapperElement = getWrapperElement(element);
    const state = getState(wrapperElement);
    if (state)
    {
        state.features.settings.readOnly = !isEnabled;
    }
    return wrapperElement ?? undefined;
}

export function toggleVisible(element: JQuery<HTMLElement>, isVisible: boolean, animate?: boolean): JQuery<HTMLElement> | undefined
{
    const wrapperElement = getWrapperElement(element);
    const state = getState(wrapperElement);
    if (state)
    {
        if (animate)
        {
            wrapperElement?.animateToggle(isVisible);
        }
        else
        {
            wrapperElement?.toggle(isVisible);
        }
    }
    return wrapperElement ?? undefined;
}